import { ReportingGroupListEntry, ReportingGroup } from './reporting-group-administration.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class ReportingGroupAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getReportinGroupListEntries(): Observable<ReportingGroupListEntry[]> {
    return this.appServerAPI.execute<ReportingGroupListEntry[]>('/client/admin/reporting-group', {});
  }

  public getReportinGroup(reportingGroupId: number): Observable<ReportingGroup> {
    return this.appServerAPI.execute<ReportingGroup>('/client/admin/reporting-group/reporting-group', reportingGroupId);
  }

  public saveReportingGroup(details: ReportingGroup): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/reporting-group/save', details);
  }

  public deleteReportingGroup(reportingGroupId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/reporting-group/delete', reportingGroupId);
  }
}
